export enum SchoolConnectReasonEnum {
  COMPLAINT_RESOLUTION = 1,
  RELATIONSHIP = 2,
  VISIT_PLAN = 3,
  BOOK_DISPATCH = 4,
  ACADEMIC_ISSUES = 5,
  REPORTS_RELATED = 6,
  TEST_SUPPORT = 7,
  EXAM_SUPPORT = 8,
  TECH_ISSUES = 9,
  PRODUCT_TRAINING = 10,
  APP_USAGE = 11,
  MAGIC_ON_THE_FIELD = 12,
}

export enum CommunicationTypeEnum {
  CALL = 1,
  WHATSAPP = 2,
  EMAIL = 3,
  GOOGLE_MEETING = 4,
  CONNECT_ALONG_WITH_LEAD_TEAM = 5,
  SCHOOL_VISIT = 6,
}

export enum SchoolConnectStatusEnum {
  NEW = 1,
  CALL_AGAIN = 2,
  EMAIL_FOLLOW_UP = 3,
  ESCALATION = 4,
  RESOLVED = 5,
}

export enum SchoolQueryCategoryEnum {
  TECH_RELATED = 1,
  CURRICULUM_AND_PEDAGOGY = 2,
  INFRA_RELATED = 3,
  ASM_RELATED = 4,
  DISPATCH_RELATED = 5,
  SCHOOL_EXPECTATION = 6,
  PEOPLE_ALIGNMENT = 7,
  PROCESS_ALIGNMENT = 8,
  PROGRAM_EXPECTATION = 9,
  OTHER = 10,
}

export enum SchoolQuerySourceEnum {
  SCHOOL_VISIT = 1,
  WHATSAPP_CALL = 2,
  THROUGH_CSM_AM = 3,
}

export enum SchoolQueryStatusEnum {
  PENDING = 1,
  IN_PROGRESS = 2,
  RESOLVED = 3,
}

export enum SchoolQueryAlignmentEnum {
  YES_WHATSAPP_AND_MAIL = 1,
  YES_WHATSAPP = 2,
  YES_CALL = 3,
  NO = 4,
}

export enum WeeksInMonthEnum {
  WEEK_1 = 1,
  WEEK_2 = 2,
  WEEK_3 = 3,
  WEEK_4 = 4,
}

export enum ProgramTypeEnum {
  HYBRID = 1,
  SERIES_PLUS = 2,
  SERIES_PRO = 3,
  OFFILINE = 4,
}

export enum CurriculumTypeEnum {
  INTEGRATED_1 = 1,
  INTEGRATED_2 = 2,
  ADVANCED = 3,
}

export enum SchoolUserRoleIdEnum {
  AEM = 1,
  CSM = 3,
  SPOC = 2,
  KDM = 4,
  PRINCIPAL = 5,
}

export enum ExternalSchoolUserRoleIdEnum {
  SPOC = 2,
  KDM = 4,
  PRINCIPAL = 5,
}

export enum MeetingStatusEnum {
  SCHEDULED = 1,
  RESCHEDULED = 2,
  COMPLETED = 3,
}

export enum MeetingCategoryEnum {
  UPCOMING = 1,
  COMPLETED = 2,
  CANCELLED = 3,
}

export enum OriginatorEnum {
  SCHOOL = 1,
  LEAD = 2,
  SL = 3,
}

//TODO: Replace actual meeting values
export enum MonthlyMeetingTopicEnum {
  TECH_RELATED = 1,
  CURRICULUM_AND_PEDAGOGY = 2,
  INFRA_RELATED = 3,
  ASM_RELATED = 4,
  DISPATCH_RELATED = 5,
  SCHOOL_EXPECTATION = 6,
  PEOPLE_ALIGNMENT = 7,
  PROCESS_ALIGNMENT = 8,
  PROGRAM_EXPECTATION = 9,
  OTHER = 10,
}

export enum PdfReportStatusEnum {
  PENDING = 1,
  PROCESSING = 2,
  GENERATED = 3,
  FAILED = 4,
}

export enum SchoolReviewTabsEnum {
  SCHOOL_CONNECTS = "Connects",
  SCHOOL_QUERIES = "Queries",
  SCHOOL_MONTHLY_MEETINGS = "Monthly Meetings",
}

export enum SchoolPlanFileTypesEnum {
  ACADEMIC_PLAN = "Academic Plan",
  ASSESSMENT_PLAN = "Assessment Plan",
  ASSESSMENT_BLUEPRINTS = "Assessment Blueprints",
  SCHOOL_ACADEMIC_CALENDAR = "School Academic Calendar",
}

export enum SchoolAssessmentIdsEnum {
  FORMATIVE_ASSESSMENT_1 = 1,
  FORMATIVE_ASSESSMENT_2 = 2,
  MOY = 3,
  FORMATIVE_ASSESSMENT_3 = 4,
  FORMATIVE_ASSESSMENT_4 = 5,
  EOY = 6,
}

export enum SchoolAssessmentNamesEnum {
  FORMATIVE_ASSESSMENT_1 = "FA1",
  FORMATIVE_ASSESSMENT_2 = "FA2",
  MOY = "MoY",
  FORMATIVE_ASSESSMENT_3 = "FA3",
  FORMATIVE_ASSESSMENT_4 = "FA4",
  EOY = "EoY",
}
